<script>
    import {getGPTransFunc} from "./gp-translations.js";
    import GPPickerFilter from "./gp-pickerfilter.svelte";
    import {textFilter, typeFilter} from "./gp-structurepickerstore.js";
    import {activePickerItem, activePickerStructureVariant} from "./gp-context-items";
    import {GPTypeCustomStructure} from "./gp-typecustomstructure";
    $: hsvActive = !($activePickerItem instanceof GPTypeCustomStructure);
    export let hsvAdjuster;
    $: {
        if ($activePickerItem) {
            hsvAdjuster.close();
        }
    }

    let trans = getGPTransFunc("gp-structurepickerfilters");
    let typeFilterValues = [
        {"id": "filterAll", "label": "All", "icon": "bench.svg"},
        {"id": "filterCustom", "label": "Your objects", "icon": "custom.svg"},
        {"id": "filterBench", "label": "Benches and chairs", "icon": "bench.svg"},
        {"id": "filterFence", "label": "Fences and trellis", "icon": "fence.svg"},
        {"id": "filterHut", "label": "Sheds and gazeboos", "icon": "hut.svg"}
    ];

    function adjustHSV() {
        let initialHSV = {h: 0, s: 0, v: 0};
        let updater = (ph, ps, pv) => {
            $activePickerStructureVariant = {
                h: ph,
                s: ps,
                v: pv
            }
        };
        hsvAdjuster.getHSV(initialHSV, updater);
    }

</script>


<div class="btn-group dropup GPSearchButtons">
    <GPPickerFilter componentClass="GPFilerStructTypes"  filterValues={typeFilterValues} bind:filter={$typeFilter} trans={trans}/>

    {#if $activePickerItem && $activePickerItem['variants']}
    <div class="btn-group btn-group-xs GPStructVariantPrevs" role="group">
        <label tabindex="0" class="btn btn-default" class:active="{!$activePickerStructureVariant}" on:click={hsvAdjuster.close}><input type="radio" bind:group={$activePickerStructureVariant} value={null}><img src="{$activePickerItem.staticGetPathForThumb()}"/></label>
        {#each $activePickerItem['variants'] as variant}
            <label tabindex="0" class="btn btn-default" class:active="{variant === $activePickerStructureVariant}" on:click={hsvAdjuster.close}><input type="radio" bind:group={$activePickerStructureVariant} value={variant}><img style="filter: hue-rotate({-variant.h}deg) saturate({1 + variant.s / 3 }) brightness({1 + variant.v / 2})" src="{$activePickerItem.staticGetPathForThumb()}"/></label>
        {/each}
    </div>
    {/if}

    {#if hsvActive}
    <div class="btn-group btn-group-xs " role="group">
        <a href="#" tabindex="0" class="btn btn-default" on:click={() =>{adjustHSV()}}><i class="fas fa-adjust" style="font-size: 16px; padding: 8px;" title={trans("Adjust colors")}></i></a>
    </div>
    {/if}

    <div class="GPStructureSearchText GPSearchText">
        <input bind:value={$textFilter} type="text" class="form-control"
               placeholder="{trans('Search for')}..."
               aria-label="{trans('Search for structures')}"/>
    </div>

    <button on:click={() => {$typeFilter = "filterAll"; $textFilter = ""}}
            class="btn btn-default GPSearchClear GPStructureSearchClear" type="button"
            aria-label="{trans('Clear filters')}">×
    </button>

</div>
